export default {
    '404': 'Sorry, page not found!',
    '500': 'The server isn’t responding. Please try again.',
    '503': 'Server updating. Please try later',

    btnHome:'Return home'
}
